import React from "react"
import { useAdminPreviewDocuments, useAdminPreviewDocument } from "@/lib/queries"
import { SupplementalListView } from "@/components/shared/SupplementalListView"

export function AdminSupplementalPage() {
  const { data: docs = [], isLoading } =
    useAdminPreviewDocuments("supplemental")

  return (
    <SupplementalListView
      docs={docs}
      isLoading={isLoading}
      useDocumentDetail={useAdminPreviewDocument}
    />
  )
}
